import React, { useState, useEffect } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { ResourceLinks } from "../../../../constants";
import { floatOnly } from "../../../../utils";

const CustomAccordion = styled(Accordion)(({ theme }) => ({
    "&:before": {
        display: "none",
    },
    "&.MuiAccordion-root.Mui-expanded": {
        marginTop: 0,
        marginBottom: 0,
    },
}));

const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    backgroundColor: "rgb(217, 217, 217)",
    borderBottom: "none",
    "&.Mui-expanded": {
        backgroundColor: "rgb(0, 176, 240)",
        borderBottom: "10px solid rgb(0, 133, 180)",
    },
}));

export default function WebNumeracyScenario({ question, onAnswer = () => {} }) {
    const questionData = question;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [expanded, setExpanded] = useState("panel1");

    const [inputValue, setInputValue] = useState("");

    const [answer, setAnswer] = useState(questionData.data.initialState);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setExpanded("panel1");
        setInputValue("");
        setAnswer(questionData.data.initialState);
    }, [question, questionData.data.initialState]);

    const handleChangeInput = (key, e) => {
        if (floatOnly(e.target.value) || e.target.value === "") {
            const value = e.target.value;
            setInputValue(value);

            processAnswer(key, value);
        }
    };

    const handleTableInput = (key, e) => {
        if (floatOnly(e.target.value) || e.target.value === "") {
            const value = e.target.value;
            processAnswer(key, value);
        }
    };

    const processAnswer = (key, value) => {
        let ans = {};
        ans[key] = value.toString();
        const newAnswer = { ...answer, ...ans };

        setAnswer(newAnswer);
        checkCanProceed(newAnswer);
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const checkCanProceed = (ans) => {
        const answerKeys = Object.keys(ans);

        let canProceed = false;
        answerKeys.map((keys) => {
            if (ans[keys] !== "" && ans[keys] !== null) {
                canProceed = true;
            }
            return null;
        });

        onAnswer({
            canProceed,
            answer: ans
        });
    }

    return (
        <Box sx={{ maxWidth: 1100, margin: "0 auto", padding: "20px" }}>
            {/* Scenario Accordion */}
            <CustomAccordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
            >
                <CustomAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="scenario-content"
                    id="scenario-header"
                >
                    <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                        {questionData.data.scenario.title}
                    </Typography>
                </CustomAccordionSummary>
                <AccordionDetails>
                    <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="wrap"
                        alignItems="left"
                        justifyContent="space-around"
                        borderTop="10px solid rgb(191, 191, 191)"
                        sx={{
                            textAlign: "left",
                        }}
                    >
                        {/* Content for Scenario */}
                        <Box flexBasis="75%">
                            <Typography
                                sx={{ fontSize: "20px", margin: "12px", fontWeight: "400" }}
                            >
                                {questionData.data.scenario.paragraph1}
                            </Typography>
                            <Typography
                                sx={{ fontSize: "20px", margin: "12px", fontWeight: "400" }}
                            >
                                {questionData.data.scenario.paragraph2}
                            </Typography>
                        </Box>

                        {/* Image for Scenario */}
                        <Box flexBasis="25%">
                            <Box component="img"
                                src={`${imagesResources}${questionData.data.scenario.image.src}`}
                                alt={questionData.data.scenario.image.alt}
                                sx={{ width: "100%" }}
                            />
                        </Box>
                    </Box>
                </AccordionDetails>
            </CustomAccordion>

            {/* Answer Accordion */}
            <CustomAccordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
            >
                <CustomAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="answer-content"
                    id="answer-header"
                >
                    <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                        {questionData.data.answerSection.title}
                    </Typography>
                </CustomAccordionSummary>
                <AccordionDetails>
                    <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="wrap"
                        alignItems="center"
                        justifyContent="space-around"
                        borderTop="10px solid rgb(191, 191, 191)"
                    >
                        <Box sx={{
                            padding: "10px",
                            textAlign: "center",
                        }}>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                width: "100%",
                                height: "450px",
                                textAlign: "center",
                            }}>
                                <table style={{
                                    width: "700px",
                                    height: "400px",
                                    textAlign: "left",
                                    borderCollapse: "collapse",
                                    marginRight: "10px",
                                    fontSize: "22px",
                                }}>
                                    <thead style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        backgroundColor: "rgb(127, 195, 255)",
                                        fontSize: "22px",
                                    }}>
                                        <tr>
                                            {questionData.data.answerSection.tableInfo.header.map((value, index) => (
                                                <th key={index} style={{
                                                    border: "1px solid black",
                                                    padding: "4px",
                                                    textAlign: "center",
                                                    fontWeight: "bold",
                                                }}>{value}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody sx={{
                                        textAlign: "left",
                                        fontSize: "22px",
                                    }}>
                                        {/* For Question Body */}
                                        {questionData.data.answerSection.tableInfo.body.map((row, index) => (
                                            <tr key={index}>
                                                <td style={{
                                                    border: "1px solid black",
                                                    textAlign: "left",
                                                    fontWeight: "bold",
                                                }}>{row.item.value}</td>
                                                <td style={{
                                                    border: "1px solid black",
                                                    textAlign: "left",
                                                }}>{row.weeklyCost.prefix} {row.weeklyCost.value}</td>
                                                <td style={{
                                                    border: "1px solid black",
                                                    textAlign: "left",
                                                }}>{row.monthlyCost.prefix} {row.monthlyCost.value}</td>
                                                <td style={{
                                                    border: "1px solid black",
                                                    textAlign: "left",
                                                }}>
                                                    {row.annualCost.isEditable 
                                                        ? 
                                                        <Box sx={{
                                                            display: "inline-flex",
                                                            width: "150px",
                                                            fontSize: "16px",
                                                            position: "relative",
                                                            textAlign: "left",
                                                        }}>
                                                            <span style={{
                                                                fontSize: "22px",
                                                            }}>{row.annualCost.prefix}</span>
                                                            <input type="text" 
                                                                value={answer[row.annualCost.stateKey]}
                                                                style={{
                                                                    height: "100%",
                                                                    padding: "2px",
                                                                    boxSizing: "border-box",
                                                                    width: "100%",
                                                                    outline: "none",
                                                                    border: "none",
                                                                    borderBottom: "2px solid #888888",
                                                                    fontSize: "22px",
                                                                    textAlign: "left",
                                                                    marginLeft: "2px",
                                                                }}
                                                                onChange={(event) => handleTableInput(row.annualCost.stateKey, event)}
                                                            />
                                                        </Box>
                                                        : 
                                                        row.annualCost.prefix + ' ' + row.annualCost.value
                                                    }
                                                </td>
                                            </tr>
                                        ))}

                                        {/* For Question Footer */}
                                        {questionData.data.answerSection.tableInfo.footer.map((row, index) => (
                                            <tr key={index}>
                                                <td colSpan={3} style={{
                                                    textAlign: "right",
                                                    fontWeight: "bold",
                                                    paddingRight: "5px",
                                                    fontSize: "22px",
                                                }}>{row.value}</td>
                                                <td style={{
                                                    border: "1px solid black",
                                                    textAlign: "left",
                                                }}>
                                                    <Box sx={{
                                                        display: "inline-flex",
                                                        width: "150px",
                                                        fontSize: "16px",
                                                        position: "relative",
                                                        textAlign: "left",
                                                    }}>
                                                        <span style={{
                                                            fontSize: "22px",
                                                        }}>{row.prefix}</span>
                                                        <input type="text" 
                                                            value={answer[row.stateKey]}
                                                            style={{
                                                                height: "100%",
                                                                padding: "2px",
                                                                boxSizing: "border-box",
                                                                width: "100%",
                                                                outline: "none",
                                                                border: "none",
                                                                borderBottom: "2px solid #888888",
                                                                fontSize: "22px",
                                                                textAlign: "left",
                                                                marginLeft: "2px",
                                                            }}
                                                            onChange={(event) => handleTableInput(row.stateKey, event)}
                                                        />
                                                    </Box>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "space-evenly",
                                    width: "320px",
                                    textAlign: "center",
                                }}>
                                    <p style={{
                                        fontSize: "24px",
                                        width: "300px",
                                        textAlign: "center",
                                    }}>{questionData.data.answerSection.question}</p>

                                    <Box
                                        sx={{
                                            borderRadius: "5px",
                                            borderBottom: "10px solid rgb(91, 105, 107)",
                                            backgroundColor: "rgb(122, 140, 142)",
                                            padding: "10px",
                                            marginBottom: "20px",
                                            width: "210px",
                                            margin: "0 auto",
                                            textAlign: "left",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: "white",
                                                marginBottom: "8px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Answer:
                                        </Typography>
                                        <TextField
                                            variant="outlined"
                                            type="text"
                                            value={inputValue}
                                            onChange={(e) => handleChangeInput("total", e)}
                                            InputProps={{
                                                autoComplete: 'off',
                                                startAdornment: "$",
                                                // endAdornment: ".00",
                                            }}
                                            sx={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                borderRadius: "5px",
                                                input: {
                                                    padding: "12px 4px 12px 4px",
                                                }
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </AccordionDetails>
            </CustomAccordion>
        </Box>
    );
};